module.exports = __webpack_public_path__ + "static/media/IMG_20180112_185957.5b5484b7.jpg";